import classNames from 'classnames/bind'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from "draftjs-to-html"
import htmlToDraft from 'html-to-draftjs'

import FormControlWrapper from '../FormControlWrapper'


class TextArea extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editor: null,
      editorState: null
    }
    this.handleChange = this.handleChange.bind(this)
  }
  componentDidMount() {
    const editorState = this.initEditorState(this.props.initialValue)
    this.setState({
      editor: Editor,
      editorState: editorState
    })

    this.props.wysiwyg ? this.changeValue(editorState) : null
  }
  initEditorState(html = '') {
    const contentBlock = htmlToDraft(html)
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
    return EditorState.createWithContent(contentState)
  }
  handleChange(editorState) {
		this.setState({ editorState })
    this.changeValue(editorState)
  }
  changeValue(editorState) {
    const value = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    this.props.input.onChange(value)
  }
  render() {
    const ClientEditor = this.state.editor
    const { editorState } = this.state
    return (
      <FormControlWrapper
        name={this.props.name}
        label={this.props.label}
        required={this.props.required}
        horizontal={this.props.horizontal}
        error={this.props.formComponent ? (this.props.touched ? this.props.error : '') : this.props.error}
        help={this.props.help}
        size={this.props.size}
        disabled={this.props.disabled}
      >
        { this.props.wysiwyg && this.state.editor ?
          <ClientEditor
            readOnly={this.props.disabled}
            editorState={editorState}
            onEditorStateChange={editorState => this.handleChange(editorState)}
          />
        : (
          <textarea
            cols={this.props.cols}
            rows={this.props.rows}
            value={this.props.input.value}
            className={classNames({
              'input': true,
              'is-static': this.props.isStatic,
              [`is-${this.props.size}`]: this.props.size,
              [this.props.className]: this.props.className
            })}
            style={this.props.style}
            name={this.props.name}
            maxLength={this.props.maxLength}
            onChange={this.props.handleChange}
            onPaste={this.props.onPaste}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
            placeholder={this.props.placeholder}
            disabled={this.props.disabled}
            readOnly={this.props.isStatic}
          />
        ) }
      </FormControlWrapper>
    )
  }
}

TextArea.defaultProps = {
  disabled: false,
  touched: false,
  formComponent: false,
  type: 'text',
  size: 'small',
  cols: 120
}

export default TextArea



// WEBPACK FOOTER //
// ./components/uiLib/TextArea/TextArea.js